import React from 'react';
import Helmet from 'react-helmet';
import { useSiteMetadata } from 'hooks/useSiteMetadata';
import HeaderNav from 'components/HeaderNav';
import Main from 'components/Main';
import Footer from 'components/Footer';
import '../../styles/global.scss';
import './Layout.scss';

const Index = ({ children }) => {
	const { title } = useSiteMetadata();

	return (
		<div className="site-container">
			<Helmet
				htmlAttributes={{
					lang: 'en',
				}}>
				<title>{title}</title>
			</Helmet>

			<div className="layout-wrapper">
				<div className="layout">
					<HeaderNav />
					<Main children={children} />
					<Footer />
				</div>
			</div>
		</div>
	);
};

export default Index;
